import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';
import { Note, NoteContextEnum } from '../types/note';
import queryClient from '../query-client';

export type CreateNoteRequest = {
    note: {
        rawMessage: string;
        structuredMessage: { [key: string]: unknown };
        context: { type: NoteContextEnum; id: string };
    };
};

async function createNote(req: CreateNoteRequest): Promise<{ note: Note }> {
    const { data } = await api.post(`/notes`, req);
    return data;
}

export function useCreateNote(): UseMutationResult<{ note: Note }, AxiosError, CreateNoteRequest, unknown> {
    return useMutation((req) => createNote(req), {
        onSettled: () => {
            queryClient.invalidateQueries(['notes']);
        },
    });
}
